export const ROUTES = {
  ROOT: '/',
  HISTORY: '/history',
  SERVICES: '/services',
  NEWS: '/news',
  SHOP: '/shop',
  CONTACT: '/contact',
  PRODUCT: '/product',
  CART: '/cart',
  CHECKOUT: '/checkout',
  REVIEW: '/review',
  TERMS: '/terms',
  COOKIE: '/cookie-policy',
  FAQ: '/faq',
  NEWS_SINGLE: '/news',
};

export const MAIN_ROUTES = [
  'checkout',
  'review',
  'product',
  'cart',
  'terms',
  'faq',
  'cookie-policy',
  'news-single',
  'news',
];

export const CURRENCIES = {
  'USD': '$',
  'GBP': '£',
};
